<form [formGroup]="inviteUsersForm" class="wrapper" *transloco="let t">
  <!-- Inviting to -->
  <span class="title"
    >{{ t('users/invitingTo') }} <strong>{{ selectedKindergarten.name }}</strong></span
  >
  <!-- Users forms -->
  <ng-container formArrayName="users">
    <div
      *ngFor="let lessonForm of inviteUsersForm.controls.users.controls; let i = index; let last = last"
      [formGroupName]="i"
      class="user"
    >
      <!-- First, Last name -->
      <div class="user-row">
        <app-text-input
          [childForm]="inviteUsersForm.controls.users.controls[i]"
          formControlName="firstName"
          [label]="t('user/firstName')"
          [required]="true"
          [formControlError]="t('user/firstNameError')"
          [requiredColor]="true"
          [customValidation]="true"
          [customErrorName]="beErrorKey"
          [formControlCustomError]="(beErrors$ | async).at(i)?.firstName"
        ></app-text-input>
        <app-text-input
          [childForm]="inviteUsersForm.controls.users.controls[i]"
          formControlName="lastName"
          [label]="t('user/lastName')"
          [required]="true"
          [formControlError]="t('user/lastNameError')"
          [requiredColor]="true"
          [customValidation]="true"
          [customErrorName]="beErrorKey"
          [formControlCustomError]="(beErrors$ | async).at(i)?.lastName"
        ></app-text-input>
      </div>
      <!-- Email, Role -->
      <div class="user-row">
        <app-text-input
          [childForm]="inviteUsersForm.controls.users.controls[i]"
          formControlName="email"
          [label]="t('user/email')"
          [required]="true"
          [formControlError]="t('user/emailError')"
          [requiredColor]="true"
          [customValidation]="true"
          [customErrorName]="beErrorKey"
          [formControlCustomError]="(beErrors$ | async).at(i)?.email"
        ></app-text-input>
        <div class="form-group col-12">
          <label for="role">{{ t('user/role') }}<span class="required-color">*</span></label>
          <ng-select
            id="role"
            formControlName="role"
            [items]="availableRoles"
            bindLabel="label"
            bindValue="value"
            [clearable]="false"
            [placeholder]="t('user/role')"
            class="form-control"
          >
          </ng-select>
        </div>
      </div>
      <!-- Add, Remove user -->
      <div class="actions">
        <div *ngIf="inviteUsersForm.controls.users.length > 1" class="action" (click)="removeUser(i)">
          <i class="material-symbols-rounded">close</i>
          <span>{{ t('user/remove') }}</span>
        </div>
        <div *ngIf="last" class="action" (click)="addUser()">
          <i class="material-symbols-rounded">add</i>
          <span>{{ t('user/next') }}</span>
        </div>
      </div>

      <!-- Spacer -->
      <div class="spacer"></div>
    </div>
  </ng-container>

  <!-- Buttons -->
  <div class="buttons">
    <button type="button" class="btn btn-outline-primary" (click)="location.back()">{{ t('child/cancel') }}</button>
    <button [disabled]="inviteUsersForm.invalid" type="submit" class="btn btn-primary" (click)="onSubmit()">
      {{ t('users/inviteUsers') }}
    </button>
  </div>
</form>
